import { City, SpecTown, Town } from "../models/IOrders";
import { configWithUserToken, configWithWebToken } from "./config";

export const getCityList = () => {
   return configWithUserToken.get<City[]>(
     "City/CityList" 
   );
};

export const getCityWithTownList = (cityId:string) => {
  return configWithUserToken.get<City>(
    "City/" + cityId
  );
};

export const postTown = (town: Town) => {
  const jsonString = JSON.stringify(town);

    return configWithUserToken.post("Town", jsonString);
  
};

export const getTownById = (townId:string) => {
  return configWithUserToken.get<SpecTown>(
    "Town/" + townId
  );
};

export const deleteTown = (townId: string) => {
  return configWithUserToken.delete("Town/" + townId);
};